import React, { useState, useEffect, useContext } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@material-ui/core';
import BugReportIcon from '@material-ui/icons/BugReport';
import { I18nContext } from 'translations';
import { registerErrorReportModal, sendErrorReport } from 'utils/errorReporter';

function ModalErrorReport() {
  const { translate } = useContext(I18nContext);
  const [open, setOpen] = useState(false);
  const [errorData, setErrorData] = useState(null);
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    registerErrorReportModal((data) => {
      setErrorData(data);
      setDescription('');
      setOpen(true);
    });
  }, []);

  const handleClose = () => {
    setOpen(false);
    setErrorData(null);
  };

  const handleSubmit = async () => {
    setLoading(true);
    await sendErrorReport({ ...errorData, description: description.trim() || undefined });
    setLoading(false);
    handleClose();
  };

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle disableTypography>
        <Box display="flex" alignItems="center">
          <BugReportIcon color="error" style={{ marginRight: 8 }} />
          <Typography variant="h6">
            <b>{translate('errorReport.title')}</b>
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent style={{ padding: '8px 24px 28px' }}>
        <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
          {translate('errorReport.subtitle')}
        </Typography>

        <TextField
          label={translate('errorReport.descriptionLabel')}
          placeholder={translate('errorReport.descriptionPlaceholder')}
          multiline
          rows={3}
          variant="outlined"
          fullWidth
          size="small"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />

        <Box display="flex" justifyContent="flex-end" style={{ marginTop: 20 }}>
          <Button
            variant="outlined"
            color="primary"
            style={{ borderRadius: '17px', marginRight: 10 }}
            onClick={handleClose}
            disabled={loading}
          >
            {translate('errorReport.skip')}
          </Button>
          <Button
            variant="contained"
            color="primary"
            style={{ borderRadius: '17px' }}
            onClick={handleSubmit}
            disabled={loading}
          >
            {translate('errorReport.send')}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default ModalErrorReport;
